import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-20 bg-brand-dark relative" data-id="element-105">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-zinc-700 to-transparent" data-id="element-106" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-108">
          {/* ESTO ES PARA TI SI */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 md:p-10" data-id="element-109">
            <h2 className="text-3xl uppercase mb-8 flex items-center gap-3" data-id="element-110">
              ESTO ES <span className="text-green-500" data-id="element-111">PARA TI</span> SI:
            </h2>
            <ul className="space-y-6" data-id="element-112">
              {['Trabajas remoto o estudias y no tienes 2 horas libres para ir y volver del gym.', 'Quieres ahorrarte los miles de pesos que cuesta una membresía hoy en día.', 'Vives en un departamento o espacio chico y no quieres llenarlo de pesas molestas.', 'Buscas un cambio físico real pero prefieres la privacidad de tu casa.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-113">
                  <div className="bg-green-500/10 p-1 rounded-full mt-1" data-id="element-114">
                    <Check className="w-5 h-5 text-green-500" data-id="element-115" />
                  </div>
                  <p className="text-zinc-300 text-lg" data-id="element-116">{text}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* ESTO NO ES PARA TI SI */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 md:p-10" data-id="element-117">
            <h2 className="text-3xl uppercase mb-8 flex items-center gap-3" data-id="element-118">
              ESTO <span className="text-red-500" data-id="element-119">NO ES PARA TI</span> SI:
            </h2>
            <ul className="space-y-6" data-id="element-120">
              {['Eres un fisicoculturista profesional que busca levantar 200kg.', 'Prefieres pagar el gimnasio y no ir que dedicarle 20 minutos de esfuerzo real en casa.', 'Buscas una solución "mágica" sin sudar ni mover un mueble.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-121">
                  <div className="bg-red-500/10 p-1 rounded-full mt-1" data-id="element-122">
                    <X className="w-5 h-5 text-red-500" data-id="element-123" />
                  </div>
                  <p className="text-zinc-300 text-lg" data-id="element-124">{text}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}